<template>
  <ul class="m-edition-map-messages-list-submenu">
    <li :class="[submenuItem === 2 ? 'item-active' : 'item-inactive', 'item-left']">
      <a
        href="#"
        class="item-messages-pending"
        @click.prevent="changeMessagesList(2)"
      >
        <i class="fas fa-comment-lines"></i>
        <span class="item-name margin-right-xsmall">Pendientes</span>
        <span
          v-if="pendingMessages > 0"
          class="text-color-danger"
        >
          ({{ pendingMessages }})
        </span>
      </a>
    </li>
    <li :class="[submenuItem === 3 ? 'item-active' : 'item-inactive', 'item-right']">
      <a
        href="#"
        class="item-messages-completed"
        @click.prevent="changeMessagesList(3)"
      >
        <i class="fas fa-comment-check"></i>
        <span class="item-name">Respondidos</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MoleculeEditionMapMessagesListSubMenu',

  props: {
    loading: {
      type: Boolean,
      default: false
    },

    submenuItem: {
      type: Number,
      default: 0
    },

    pendingMessages: {
      type: Number,
      default: 0
    }
  },

  methods: {
    changeMessagesList (item) {
      console.log(item)
      if (!this.loading) {
        this.$emit('changeMessagesList', item)
      }
    }
  }
}
</script>
